import {
    calendarNumberOutline,
    calendarClearOutline,
    listOutline,
    calendarOutline,
    chatbubblesOutline,
    notificationsOutline,
    home,
    calendarNumber,
    calendarClear,
    list,
    calendar,
    chatbubbles,
    notifications,
    people,
    personCircle,
    lockClosed,
    construct,
    constructOutline,
} from 'ionicons/icons';

export const mainMenu = [
    {
        label: 'Create Reservation',
        icon: calendarNumberOutline,
        color: 'success',
        url: '/createReservation',
        scopes: ['reservation:write'],
        roles: [],
    },
    {
        label: 'Create Block',
        icon: calendarClearOutline,
        color: 'secondary',
        url: '/createBlock',
        scopes: ['reservation:write'],
        roles: [],
    },
    {
        label: 'View Reservations',
        icon: listOutline,
        color: 'warning',
        url: '/reservationsList',
        scopes: ['reservation:read'],
        roles: [],
    },
    {
        label: 'Calendar Tape',
        icon: calendarOutline,
        color: 'primary',
        url: '/calendarPage',
        scopes: ['calendar:read', 'calendar:write'],
        roles: [],
    },
    {
        label: 'Unified Inbox',
        icon: chatbubblesOutline,
        color: 'dark',
        url: '/unifiedInbox',
        scopes: ['inbox:read', 'inbox:write'],
        roles: [],
    },
    {
        label: 'Work Orders',
        icon: constructOutline,
        color: 'tertiary',
        url: '/workOrders',
        scopes: ['workorder:read'],
        roles: [],
    },
    {
        label: 'Notifications',
        icon: notificationsOutline,
        color: 'danger',
        url: '/notifications',
        scopes: [],
        roles: [],
    },
];

export const sideMenu = [
    {
        title: 'Home',
        id: 'HOME',
        url: '/home',
        iosIcon: home,
        mdIcon: home,
        keyWords: 'home',
        scopes: [],
        roles: [],
    },
    {
        title: 'Create Reservation',
        id: 'CREATE_RESERVATION',
        url: '/createreservation',
        iosIcon: calendarNumber,
        mdIcon: calendarNumber,
        keyWords: 'create reservation booking new reservation',
        scopes: ['reservation:write'],
        roles: [],
    },
    {
        title: 'Create Block',
        id: 'CREATE_BLOCK',
        url: '/createBlock',
        iosIcon: calendarClear,
        mdIcon: calendarClear,
        keyWords: 'create block blocking new blocking property blocking',
        scopes: ['reservation:write'],
        roles: [],
    },
    {
        title: 'View Reservations',
        id: 'VIEW_RESERVATIONS',
        url: '/reservationsList',
        iosIcon: list,
        mdIcon: list,
        keyWords: 'view reservations calendar guest reservations all reservations all blocking',
        scopes: ['reservation:read'],
        roles: [],
    },
    {
        title: 'Calendar Tape',
        id: 'CALENDAR_TAPE',
        url: '/calendarPage',
        iosIcon: calendar,
        mdIcon: calendar,
        keyWords: 'calendar tape view calendar all reservations all blocking',
        scopes: ['calendar:read', 'calendar:write'],
        roles: [],
    },
    {
        title: 'Unified Inbox',
        id: 'UNIFIED_INBOX',
        url: '/unifiedInbox',
        iosIcon: chatbubbles,
        mdIcon: chatbubbles,
        keyWords: 'chat unified inbox messages',
        scopes: ['inbox:read', 'inbox:write'],
        roles: [],
    },
    {
        title: 'Work Orders',
        id: 'WORK_ORDERS',
        url: '/workOrders',
        iosIcon: construct,
        mdIcon: construct,
        keyWords: 'work orders',
        scopes: ['workorder:read'],
        roles: [],
    },
    {
        title: 'Notifications',
        id: 'NOTIFICATIONS',
        url: '/notifications',
        iosIcon: notifications,
        mdIcon: notifications,
        keyWords: 'notifications alert',
        scopes: [],
        roles: [],
    },
    {
        title: 'Support',
        id: 'SUPPORT',
        url: '/support',
        iosIcon: people,
        mdIcon: people,
        keyWords: 'help customer support chat documents intercom lodgix support',
        scopes: [],
        roles: ['Subscriber', 'Super User', 'Front Desk'],
    },
    {
        title: 'Account',
        id: 'ACCOUNT',
        url: '/account',
        iosIcon: personCircle,
        mdIcon: personCircle,
        keyWords: 'account information signout about version logout profile support help customer service',
        scopes: ['userinfo:read', 'userinfo:write'],
        roles: [],
    },
    {
        title: 'Sign Out',
        id: 'SIGN_OUT',
        url: '/signout',
        iosIcon: lockClosed,
        mdIcon: lockClosed,
        keyWords: 'signout logout',
        scopes: [],
        roles: [],
    },
];

export const workOrderPriorityColors = {
    CRITICAL: '#cf3c4f',
    URGENT: '#eb445a',
    HIGH: '#f56800',
    MEDIUM: '#ffc409',
    LOW: '#6370ff',
    PROJECT: '#1055c4',
    DEFAULT: '#1055c4',
};

export const workOrderStatusColors = {
    OPEN: '#ffc409',
    CANCELLED: '#eb445a',
    ESCALATED: '#eb445a',
    CLOSED: '#4caf50',
    DEFAULT: '#1055c4',
};
